import { InfoIcon } from "icons/payments/InfoIcon";
import React from "react";
import Exclaim from "../../src/utils/exclaim.svg";
import CustomTooltip from "./CustomTooltip";
import { usePortalSettingsData } from "store/slices/dashboardSlice";
// import CustomTooltip from './CustomTooltip';
interface TabsProps {
  old?: boolean;
  totalTabs?: any;
  selected?: any;
  setSelected?: any;
  disableHover?: boolean;
  disabled?: boolean;
  isInfo?: boolean;
}
const TabsComp = ({
  old = false,
  totalTabs = [],
  selected,
  setSelected,
  disableHover = false,
  disabled = false,
  isInfo = false,
}: TabsProps) => {
  const portalSettings = usePortalSettingsData();
  return (
    <div className="flex h-full">
      {totalTabs.map((itm: any, idx: number) => (
        <div
          key={idx}
          aria-disabled={disabled || disableHover}
          className={`${idx === 0 && "rounded-l-[7px]"} ${
            idx === totalTabs.length - 1 && "rounded-r-[7px]"
          }
        ${
          (old ? selected === itm : selected?.value === itm.value)
            ? "text-btnPrimaryActive bg-btnOutlineHover border-[#D3E7FF]"
            : disabled
              ? "text-txtSecondary bg-bgThird border-strokePrimary"
              : "text-txtPrimary border-strokePrimary"
        }
        flex gap-[3px] justify-center items-center border-[1px] grow h-full ${
          disabled
            ? "cursor-not-allowed"
            : disableHover
              ? "cursor-default"
              : "hover:!bg-bgThird cursor-pointer"
        }`}
          onClick={() => {
            if (!disabled && !disableHover) setSelected(itm);
          }}
        >
          <p className="text-xs font-normal leading-[18px]">
            {old ? itm : itm.name}
          </p>
          {isInfo &&
            (old ? selected === itm : selected?.value === itm.value) && (
              <CustomTooltip
                maxwidth="430px"
                place="top"
                id={`${old ? itm : itm.name}-anchor`}
                content={`<div class="text-xs leading-[18px] font-normal max-w-[200px]">A <span class="lowercase">
                  ${
                    portalSettings?.cc_fee_label
                      ? portalSettings?.cc_fee_label
                      : "convenience fee"
                  }
                </span> is added to each payment.</div>`}
              >
                <InfoIcon
                  id={`${old ? itm : itm.name}-anchor`}
                  className="cursor-pointer group"
                  _className="group-hover:!stroke-iconObscure"
                />
              </CustomTooltip>
            )}
        </div>
      ))}
    </div>
  );
};

export default TabsComp;
